"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _queryString = _interopRequireDefault(require("query-string"));

var _commonReact = require("@devsta/common-react");

var _flashInput = _interopRequireDefault(require("../utils/flashInput"));

require("../styles/_header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var HEADER_CLASS = 'video-tool-header';

function getOptions(_ref) {
  var viewDetails = _ref.viewDetails,
      videoPermissions = _ref.videoPermissions;
  var actionOptions = [{
    action: viewDetails,
    label: 'View Details',
    requiredPermission: 'READ'
  }];
  return actionOptions.filter(function (_ref2) {
    var requiredPermission = _ref2.requiredPermission;
    return (0, _commonReact.hasPermission)(requiredPermission, videoPermissions);
  });
}

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "updateName", function (_ref3) {
      var value = _ref3.target.value;
      var canUpdateVideo = _this.props.canUpdateVideo;

      if (canUpdateVideo) {
        _this.setState({
          name: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "saveName", function () {
      var name = _this.state.name;
      var _this$props = _this.props,
          onUpdateVideo = _this$props.onUpdateVideo,
          canUpdateVideo = _this$props.canUpdateVideo;

      if (!canUpdateVideo || !name) {
        return void _this.setState({
          name: _this.props.name
        });
      }

      onUpdateVideo({
        name: name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getTitle", function () {
      var _this$props2 = _this.props,
          video = _this$props2.video,
          _this$props2$queryPar = _this$props2.queryParams,
          sourcingassets = _this$props2$queryPar.sourcingassets,
          commentclip = _this$props2$queryPar.commentclip,
          title = _this$props2.title;

      if (sourcingassets) {
        return 'Media Library';
      }

      if (commentclip) {
        return title || 'Unknown Clip';
      }

      return video && video.name;
    });

    _this.state = {
      name: props.name || ''
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.loading && !this.props.loading) {
        var _this$props3 = this.props,
            fetchCollaborationData = _this$props3.fetchCollaborationData,
            organisationId = _this$props3.organisationId;
        fetchCollaborationData(organisationId);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          currentStage = _this$props4.currentStage,
          onClickStage = _this$props4.onClickStage,
          drawerRef = _this$props4.drawerRef,
          canUpdateVideo = _this$props4.canUpdateVideo,
          videoPermissions = _this$props4.videoPermissions,
          video = _this$props4.video,
          loading = _this$props4.loading,
          _this$props4$queryPar = _this$props4.queryParams,
          sourcingassets = _this$props4$queryPar.sourcingassets,
          commentclip = _this$props4$queryPar.commentclip,
          submitted = _this$props4.submitted;
      var masterOutputIndex = video ? video.outputs.findIndex(function (output) {
        return output.isMaster;
      }) : -1;

      var _ref4 = video ? video.outputs[masterOutputIndex] : {
        status: {}
      },
          status = _ref4.status.name;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: HEADER_CLASS
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Drawer.DrawerTrigger, {
        drawerRef: drawerRef
      }, function (_ref5) {
        var viewDetails = _ref5.onClick;
        return /*#__PURE__*/_react.default.createElement(_commonReact.CollaborationPageHeader, {
          loading: loading,
          key: "header__ph",
          editableTitle: !loading && canUpdateVideo && !sourcingassets && !commentclip,
          title: _this2.getTitle(),
          breadCrumbs: [{
            title: 'Home',
            url: '/'
          }, {
            title: 'Projects',
            url: '/video-tool'
          }, sourcingassets || commentclip ? {
            title: video && video.name,
            url: "/video-tool/builder/".concat(video && video.videoId, "#1")
          } : void 0].filter(Boolean),
          actionPopupOptions: getOptions({
            viewDetails: viewDetails,
            videoPermissions: videoPermissions,
            canUpdateVideo: canUpdateVideo
          }),
          onChangeTitle: _this2.updateName,
          onBlurTitle: _this2.saveName,
          actionPopupBackgroundColor: "tundora",
          hideMembers: Boolean(sourcingassets)
        });
      }), sourcingassets || loading || commentclip ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(HEADER_CLASS, "__stages column")
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Stages, {
        onClick: onClickStage,
        currentStage: currentStage,
        stages: [{
          text: 'Upload Assets'
        }, {
          text: 'Brief the Editor'
        }, {
          text: 'Addons & Extras'
        }, {
          text: status === 'DRAFT' || submitted ? 'Confirmation' : 'Summary',
          disabled: status === 'DRAFT'
        }]
      })));
    }
  }]);

  return Header;
}(_react.Component);

exports.default = Header;